<div *ngFor="let notification of notifications" class="position-fixed top-0 end-0 p-3" style="z-index: 1050;">
    <div [ngClass]="{
          'alert': true,
          'fade': true,
          'show': !notification.fadeOut,
          'alert-success': notification.type === 'success',
          'alert-danger': notification.type === 'error',
          'alert-warning': notification.type === 'warning'
        }">
      {{ notification.message }}
    </div>
  </div>